import React from 'react';

import { Loader } from '@eika/loader';

import { Error } from '../components/error/error';
import { Skjemaside } from '../utils/piwik-utils';
import { CurrentSteg, CurrentStegTypes } from './reducer/current-steg';
import { SporsmalCard } from './sporsmalCard';

interface Props {
    currentSteg: CurrentSteg;
    Oppsummering: React.FC;
    skjemaside: Skjemaside;
    onPrev: () => void;
    retryFetchingData: () => void;
}

export const Sporsmalsflytsteg = ({ currentSteg, onPrev, skjemaside, Oppsummering, retryFetchingData }: Props) => {
    switch (currentSteg.type) {
        case CurrentStegTypes.Loading:
            return <Loader />;

        case CurrentStegTypes.Failure:
            return (
                <Error
                    headerText="Her gikk noe galt – prøv igjen!"
                    bodyText="Dersom feilen gjentar seg flere ganger, kan du ringe oss på tlf 915&nbsp;03&nbsp;850."
                    errorButtonProps={{
                        buttonText: 'Prøv igjen',
                        buttonDataTrackId: 'error-button-prov-igjen',
                        onButtonClick: retryFetchingData,
                        sideDetail: skjemaside,
                    }}
                    className="sporsmalsflytsteg-error"
                />
            );

        case CurrentStegTypes.Sporsmal:
            return (
                <SporsmalCard
                    currentSporsmal={currentSteg.currentSporsmal}
                    onPrevious={onPrev}
                    skjemaside={skjemaside}
                />
            );

        case CurrentStegTypes.Oppsummering:
            return <Oppsummering />;

        default:
            return null;
    }
};
